import React, { FC, useEffect, useState } from 'react';
import './CompanyInformation'
import { ICompany } from '../../../entities/Company'

interface IThemFormProps {
    data: ICompany;
    onChange?: (prop: string, value: any) => void;
    imgUploaded?: string;
    errors?: any;
}
export interface ICompanyesUser {
    companyId: string;
    companyName: string;
}
const CompanyInformation: FC<IThemFormProps> = ({ data, onChange, imgUploaded,errors }) => {
    const [currentCompanySelected, setCurrenCompanySelected] = useState<ICompanyesUser[]>([]);

    useEffect(() => {
        const companies = JSON.parse(localStorage.getItem("company_jwt") || '[]') as ICompanyesUser[];
        setCurrenCompanySelected(companies);
    }, [])

    useEffect(() => {
        

    },[errors])

    return (
        <div className=" justify-center  max-w-5xl flex-row md:flex lg:ml-72 mb-3">
            <div className="w-full flex justify-center md:justify-start  md:w-1/4">
                <p className="text-lg font-bold text-customBlue">Company Information</p>
            </div>
            <div className="m-3 md:w-3/4 mt-6">
                <div className="flex flex-row pb-3 md:w-1/2">
                    <select 
                        required={errors["id"] === 1 ? true:false}
                        disabled={window.location.pathname.includes("/edit") ? true : false}
                        value={data.successwareCompanyId}
                        className={`w-full rounded ${errors["id"] === 1 ? "custom-input-sm-successware-error": "custom-input-sm-successware"}`}
                        onChange={(value) => onChange?.("successwareCompanyId", value.target.value)}
                    >
                        <option className="ml-3" value="">Choose a Company</option>
                        {currentCompanySelected.map(val => {
                            return <option className="ml-3" value={val.companyId}>{`${val.companyId} - ${val.companyName} `}</option>
                        })}
                    </select>
                    <div className="absolute -mt-1 ml-1 bg-white">
                        <p className="custom-fixed-label   mr-1">Which Company</p>
                    </div>
                    <p className="text-red-500 my-auto ml-1 mr-5">*</p>
                </div>
                <div className="flex flex-row pb-3">
                    <input
                        required={errors["name"] === 1 ? true:false}
                        className={`w-full rounded ${errors["name"] === 1 ? "custom-input-sm-successware-error": "custom-input-sm-successware "} pl-3`}
                        type="text" placeholder="Company Name"
                        autoComplete="off"
                        value={data.name}
                        onChange={(value) => onChange?.("name", value.target.value)}
                    />
                    <div className="absolute -mt-1 ml-3 bg-white">
                        <p className="custom-fixed-label ml-1 mr-1 ">Company Name</p>
                    </div>
                    <p className="text-red-500 my-auto pl-1">*</p>
                </div>
                <div className="flex flex-col justify-center items-center md:flex-row">
                    <div className="w-3/3 md:mr-6">
                        <div className="flex flex-row pb-3">
                            <input
                                required={errors["streetAddress"] === 1 ? true:false}
                                className={`w-full rounded ${errors["streetAddress"] === 1 ? "custom-input-sm-successware-error": "custom-input-sm-successware "} pl-3`}
                                type="text" placeholder="Street Address"
                                autoComplete="false"
                                value={data.streetAddress}
                                onChange={(value) => onChange?.("streetAddress", value.target.value)}
                            />
                            <div className="absolute -mt-1 ml-3 bg-white">
                                <p className="custom-fixed-label  ml-1 mr-1">Street Address or P.O Box</p>
                            </div>
                            <p className="text-red-500 my-auto pl-1">*</p>
                        </div>
                        <div className="flex flex-row pb-3">
                            <input
                                className="w-full rounded custom-input-sm-successware pl-3"
                                type="text" placeholder="Apt, Suite, Unit, Building, Floor etc."
                                autoComplete="false"
                                value={data.place}
                                onChange={(value) => onChange?.("place", value.target.value)}
                            />
                            <div className="absolute -mt-1 ml-3 bg-white">
                                <p className="custom-fixed-label  ml-1 mr-1">Apt, Suite, Unit, Building, Floor etc.</p>
                            </div>
                            <p className="text-red-500 my-auto pl-3"> </p>
                        </div>
                        <div className="flex flex-row ">
                            <div className="flex w-2/4">
                                <input
                                    required={errors["city"] === 1 ? true:false}
                                    className={`w-full rounded ${errors["city"] === 1 ? "custom-input-sm-successware-error": "custom-input-sm-successware "} pl-3`}
                                    type="text" placeholder="City"
                                    autoComplete="false"
                                    value={data.city}
                                    onChange={(value) => onChange?.("city", value.target.value)}
                                />
                                <div className="absolute -mt-1 ml-3 bg-white">
                                    <p className="custom-fixed-label  ml-1 mr-1">City</p>
                                </div>
                                <p className="text-red-500 my-auto ml-1 mr-9">*</p>
                            </div>
                            <div className="flex w-1/4">
                                <input
                                    required={errors["state"] === 1 ? true:false}
                                    className={`w-full rounded ${errors["state"] === 1 ? "custom-input-sm-successware-error": "custom-input-sm-successware "} pl-3`}
                                    type="text" placeholder="State"
                                    autoComplete="false"
                                    value={data.state}
                                    maxLength={2}
                                    onChange={(value) => onChange?.("state", value.target.value)}
                                />
                                <div className="absolute -mt-1 ml-1 bg-white">
                                    <p className="custom-fixed-label   mr-1">State</p>
                                </div>
                                <p className="text-red-500 my-auto ml-1 mr-5">*</p>
                            </div>
                            <div className="flex w-1/4">
                                <input
                                    required={errors["zipcode"] === 1 ? true:false}
                                    className={`w-full rounded ${errors["zipcode"] === 1 ? "custom-input-sm-successware-error": "custom-input-sm-successware "} pl-3`}
                                    type="text" placeholder="zip-code"
                                    autoComplete="false"
                                    value={data.zipCode}
                                    onChange={(value) => onChange?.("zipCode", value.target.value)}
                                />
                                <div className="absolute -mt-1 ml-3 bg-white">
                                    <p className="custom-fixed-label   mr-1">Zip Code</p>
                                </div>
                                <p className="text-red-500 my-auto ml-1">*</p>
                            </div>

                        </div>
                    </div>

                    <div className={` mt-3 w-1/2 md:mt-0  md:w-1/3    border-dashed border-2 border-${errors["img"] === 1 ? "red":"gray"}-300 bg-customFileButtonUploadColor flex flex-col justify-center items-center mr-3`}>
                        <div className=" mx-auto rounded-lg overflow-hidden md:max-w-xl">
                            <div className="md:flex">
                                <div className="w-full p-3">
                                    <div className="relative border-dotted  rounded-lg  flex justify-center items-center h-24">
                                        <div className="absolute">
                                            <div className="flex flex-col items-center">
                                                <img className="mb-2" src={imgUploaded} alt="png of file upload" />
                                                <p className="text-xs md:text-md custom-text-img-upload mb-1">Upload Company Logo</p>
                                                <p className="text-xs md:text-md mb-3 custom-text-png-upload text-gray-500">.png file</p>
                                            </div>
                                        </div>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            className="h-full w-full opacity-0" name=""
                                            onChange={(value) => onChange?.("img", value.target.files)}
                                            id="imageupload"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>

            </div>
        </div>
    );
}

export default CompanyInformation;